export const CLINICIAN_DATA = {
  email: 'jena.smith@gmail.com',
  id: 1,
  name: 'Jena Smith',
  profileImageUrl: null,
  practiceName: 'Practice Name',
};
export const CLINICIAN_PROFILE_IMAGE =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAIAAAD8GO2jAAAAiklEQVR4nGKJfXqFARuYFPkWq7jgg9dYxTWmcWEVZ8IqSkUwasGoBZQDlv7DB7FKXH+6B6v428LDWMV/VrFgFR/6QTRqwQiwgGX7wR9YJdRWV2IVvzLzH1Zx7SpprOJDP4hGLRgBFjDWMvFglfDW3IRVPO7wIazi1/i6sYoP/SAatWAEWAAIAAD//9xrGuOKNZkDAAAAAElFTkSuQmCC';
